export default "__VITE_ASSET__D5k765X0__"